import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-flights-skeleton',
  templateUrl: './flights-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlightsSkeletonComponent {}
